"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Icon = _interopRequireDefault(require("../../../atoms/Icon"));

var _tokens = _interopRequireDefault(require("../../../tokens"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CloseButtonContainer = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "DialogHeader__CloseButtonContainer"
})(["", ""], function (_ref) {
  var _ref$theme = _ref.theme,
      typography = _ref$theme.typography,
      palette = _ref$theme.palette;
  return (0, _styledComponents.css)(["position:absolute;right:", ";top:", ";.MuiIcon-root{cursor:pointer;color:", ";}"], typography.pxToRem(17), typography.pxToRem(17), palette.grey[900]);
});

var DialogIconContainer = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "DialogHeader__DialogIconContainer"
})(["", ""], function (_ref2) {
  var typography = _ref2.theme.typography;
  return (0, _styledComponents.css)([".MuiIcon-root{font-size:", ";opacity:80%;}"], typography.pxToRem(48));
});

var HeaderContainer = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "DialogHeader__HeaderContainer"
})(["", ""], function (_ref3) {
  var _ref3$theme = _ref3.theme,
      typography = _ref3$theme.typography,
      palette = _ref3$theme.palette;
  return (0, _styledComponents.css)(["display:flex;align-items:center;padding-top:", ";justify-content:center;position:relative;background-color:", ";border-radius:", "px ", "px 0 0;min-height:", ";"], typography.pxToRem(17), palette.common.white, _tokens["default"].borderRadius, _tokens["default"].borderRadius, typography.pxToRem(48));
});

var DialogHeader = function DialogHeader(_ref4) {
  var onClose = _ref4.onClose,
      type = _ref4.type;
  var dialogIcon = type === 'success' ? {
    icon: 'check-circle',
    color: 'secondary'
  } : type === 'error' ? {
    icon: 'exclamation-circle',
    color: 'error'
  } : null;
  return _react["default"].createElement(HeaderContainer, null, dialogIcon && _react["default"].createElement(DialogIconContainer, null, _react["default"].createElement(_Icon["default"], _extends({}, dialogIcon, {
    fontSize: "large",
    prefix: "fas"
  }))), _react["default"].createElement(CloseButtonContainer, null, onClose && _react["default"].createElement(_Icon["default"], {
    prefix: "fas",
    icon: "times",
    onClick: onClose,
    fontSize: "large"
  })));
};

var _default = DialogHeader;
exports["default"] = _default;